export default __webpack_public_path__ + "static/media/mòr.923f23a5.mp3";